import { z } from "zod";

export const schema = z
	.object({
		id_post: z.number({ required_error: "ID_POST é obrigatório" }).int(),
		id_instagram: z
			.number({
				required_error: "ID_INSTAGRAM é obrigatório",
				invalid_type_error: "ID_INSTAGRAM é obrigatório",
			})
			.int()
			.gt(0, "Selecione a conta do instagram"),

		cod_post: z.string().min(1, "Mensagem DM é obrigatório"),
		mensagem_dm: z.string().min(1, "Escolha um post do Instagram").max(2000, "Máximo 2000 caracteres").optional(),

		// aceita "" ou URL válida
		url_imagem: z.string().url("URL da imagem inválida").or(z.literal("")).optional(),
		ativo: z.boolean({ required_error: "ATIVO é obrigatório" }),

		link_mensagem_dm: z.string().url("Link inválido").or(z.literal("")).or(z.null()).optional(),
		mensagem_comentario_1: z.string().nullable(),
		mensagem_comentario_2: z.string().nullable(),
		mensagem_comentario_3: z.string().nullable(),
		titulo_link: z.string().max(100, "Máximo 100").or(z.literal("")).or(z.null()).optional(),

		// multiselect
		triggers: z.array(z.string().min(1)).nonempty("Selecione ou adicione pelo menos um canal"),
	})
	.refine(
		(data) =>
			!(data.link_mensagem_dm && data.link_mensagem_dm.trim().length > 0) ||
			(data.titulo_link && data.titulo_link.trim().length > 0),
		{
			message: "Preencha o título se informar o link.",
			path: ["titulo_link"],
		}
	)
	.refine(
		(data) =>
			!(data.titulo_link && data.titulo_link.trim().length > 0) ||
			(data.link_mensagem_dm && data.link_mensagem_dm.trim().length > 0),
		{
			message: "Preencha o link se informar o título.",
			path: ["link_mensagem_dm"],
		}
	);

export const schemaDefaultValues = {
	id_post: 0,
	id_instagram: 0,
	cod_post: "DM",
	mensagem_dm: "",
	ativo: true,
	mensagem_comentario_1: "",
	mensagem_comentario_2: "",
	mensagem_comentario_3: "",
	url_imagem: "", // "" é aceito
	link_mensagem_dm: "", // "" é aceito
	titulo_link: "", // "" é aceito
	triggers: [],
};

// import { z } from "zod";

// export const schema = z
// 	.object({
// 		id_post: z.number({ required_error: "ID_POST é obrigatório" }).int(),
// 		id_instagram: z
// 			.number({
// 				required_error: "ID_INSTAGRAM é obrigatório",
// 				invalid_type_error: "ID_INSTAGRAM é obrigatório",
// 			})
// 			.int()
// 			.gt(0, "Selecione a conta do instagram"),
// 		cod_post: z.string().min(1, "Escolha um post do Instagram"),
// 		mensagem_dm: z.string().max(500, "Máximo 500 caracteres").optional(),
// 		mensagem_comentario: z.string().max(500, "Máximo 500 caracteres").optional(),
// 		url_imagem: z.string().url("URL da imagem inválida").optional(),
// 		ativo: z.boolean({ required_error: "ATIVO é obrigatório" }),
// 		link_mensagem_dm: z.string().url("Link da mensagem/DM inválido").optional(),
// 		titulo_link: z.string().max(100, "Máximo 100 caracteres").optional(),
// 		// 👇 novo campo do multiselect: array de strings
// 		triggers: z.array(z.string().min(1)).nonempty("Selecione ou adicione pelo menos um canal"),
// 	})
// 	.refine(
// 		(data) => {
// 			if (data.link_mensagem_dm && data.link_mensagem_dm.length > 0) {
// 				return data.titulo_link && data.titulo_link.length > 0;
// 			}
// 			return true;
// 		},
// 		{
// 			message: "Se o link da mensagem/DM estiver preenchido, o título do link também deve ser preenchido.",
// 			path: ["titulo_link"],
// 		}
// 	);

// export const schemaDefaultValues = {
// 	id_post: 0,
// 	id_instagram: 0,
// 	cod_post: "",
// 	menssagem_dm: "",
// 	ativo: true,
// 	mensagem_comentario: "",
// 	url_imagem: "",
// 	link_mensagem_dm: "",
// 	titulo_link: "",
// 	triggers: [],
// };
